import { registerDataTableComponent } from '@vendure/admin-ui/core';

import {
  CreditBalanceColumnComponent,
  CreditLimitColumnComponent,
} from './currency-column.component';

export default [
  registerDataTableComponent({
    component: CreditLimitColumnComponent,
    tableId: 'company-list',
    columnId: 'creditLimit',
  }),
  registerDataTableComponent({
    component: CreditBalanceColumnComponent,
    tableId: 'company-list',
    columnId: 'creditBalance',
  }),
];
